import { useUserAffiliationDashboard } from '@hub/api/queries';
import AffiliationDashboardWrapper from './affiliation-dashboard-wrapper';
import AffiliationWelcome from './welcome/affiliation-welcome';

/**
 * Wrapper component that checks if affiliate is archived and shows appropriate component.
 * If archived, shows welcome page (where user can re-register as affiliate).
 * If not archived, shows dashboard.
 */
const AffiliationRouteWrapper = () => {
  const {
    data: affiliateData,
    isLoading,
    error,
  } = useUserAffiliationDashboard();

  // If affiliate data is loaded and affiliate is archived, show welcome page
  // Also show welcome page if there's an error (e.g., affiliate not found)
  if (!isLoading) {
    if (affiliateData?.archived || error) {
      return <AffiliationWelcome />;
    }
  }

  // If not archived or still loading, show dashboard
  return <AffiliationDashboardWrapper />;
};

export default AffiliationRouteWrapper;
